import { useColorRule } from '../../../core/color-rule/useColorRule.js';
import { DEFAULT_VALUE_ACCESSOR } from '../../../core/constants.js';
import { MeterBarChartData } from '../types/meter-bar-chart.js';

export const useMeterBarColorRule = (
  value: number | MeterBarChartData,
  valueAccessor?: string,
) => {
  const seriesForColorRule =
    typeof value === 'number'
      ? [{ value: value }]
      : ([
          {
            ...value,
            _chartValueAccessor: valueAccessor ?? DEFAULT_VALUE_ACCESSOR,
          },
        ] as { _chartValueAccessor: string; [key: string]: unknown }[]);

  const colorRule = useColorRule(
    seriesForColorRule as { value: number | MeterBarChartData }[],
    'meterBar',
  );

  return colorRule.for(
    seriesForColorRule[0] as {
      value: number | MeterBarChartData;
    },
  );
};
